import { createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import { BASE_URL, getToken } from '../asyncConfig';

export const updateConfig = createAsyncThunk(
  'config/update', async (details, {rejectWithValue, fulfillWithValue}) => {
    try {
      const { data } = await axios.put(
        `${BASE_URL}/admin/update/config`, 
        details, 
        {headers: {Authorization: `Bearer ${getToken()}`}}
      );
      return fulfillWithValue(data);
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
)

export const getConfigFulfilled = (state, action) => {
  console.log('action', action);
  state.status = '';
  state.configuration = action.payload;
}

export const getConfig = createAsyncThunk(
  'config/retreive', async (_, {rejectWithValue, fulfillWithValue}) => {
    try {
      const {data} = await axios.get(
        `${BASE_URL}/admin/retrieve/config`,
        {headers: {Authorization: `Bearer ${getToken()}`}}
      );
      return fulfillWithValue(data.configurations);
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
)